import { FunctionComponent } from "preact";
import * as d3 from 'd3';

import * as dateish from "@/dateish";
import { AppState } from "@/appstate";
import { speciesStreaks, streakDays } from "@/ebird/agg";

import DataTable from "@/ui/data_table";
import { Observation } from "@/ebird/ebird";
import { LinkDoY } from "@/ui/date_link";

export type State = { app: AppState, spcode: string }

const BirdPage: FunctionComponent<State> = (props) => {
  const { spcode, app: { store, allObservations } } = props;

  const taxon = store.taxonomy.code(spcode); // TODO: Retrun null?
  if (taxon == null) {
    return <div>404: Invalid Species Code: <pre>{ spcode }</pre></div>;
  }

  // TODO: Rock Pigeon doesn't work... because of my countAs hack - still true?
  // TODO: Figure out how to share the observation lists
  const observations = allObservations.filter(o => o.taxon.speciesCode === spcode);
  const [[, streaks]] = speciesStreaks(observations);

  return <div class='taxon-page'>
    <h2 class='species'>
      <span class='com-name'>{taxon.commonName} </span>
      <span class='sci-name'><i>{taxon.scientificName}</i></span>
    </h2>

    <BirdCal observations={ observations } />

    <div class='taxon-content'>
      <h3>Streaks</h3>
      <DataTable header={ [ 'Days', 'Start', 'End' ] }
        rows={ streaks.slice(0, 5).map(s => {
          return [ streakDays(s), dateish.yearMonDay(s[0].date), dateish.yearMonDay(s.slice(-1)[0].date) ];
        }) }/>
      <div>TODO: Link to show all streaks for the bird</div>

    </div>
  </div>;
}

// TODO: Take a list of observations and just mark the days/month w/out regard for the taxon...
// Then I can also control the rendering by saying to aggregate the observations by day
//  - e.g. checks vs counts
//  - e.g. months are species vs days
// TODO: This is the "BingoCalendar" - e.g. days that match get a dot...
export const BirdCal: FunctionComponent<{
  observations: Observation[]
}> = ({ observations }) => {

  // We want the midpoint as are checked color
  // const scheme = d3.schemeOrRd[3] as string[]; // TODO: This is the same scheme....
  // const interp = d3.interpolateRgbBasis(scheme);
  // const checked = d3.scaleSequential([0, 2], interp).unknown("");

  const byDay = d3.group(observations, obs => `${obs.date.month}-${obs.date.day}` as dateish.DoY)
  const byMonth = d3.group(observations, obs => obs.date.month, obs => obs.date.day);

  return <div class='taxon-calendar-asdf'>
    <div>{ `${byDay.size} / 366 days` }</div>
    { dateish.yearless().map(moy => {
      return <table class='taxon-month'>
        <thead>
          <tr><th colSpan={7}>
            { moy.name }
            { byMonth.get(moy.mm) &&
              <span class='taxon-month__count'> ({ byMonth.get(moy.mm)?.size })</span>
            }
          </th></tr>
        </thead>
        <tbody>
          { moy.weeks.map(week => {
            return <tr class='taxon-week'>
              { week.map(day => {
                const doy = day.date as dateish.DoY;
                const seen = byDay.get(doy) != null;
                // TODO: make a daylink wrapper?
                return <td class='taxon-day' data-seen={ seen }>
                  <LinkDoY doy={ doy } >{ day.day }</LinkDoY>
                </td>
              }) }
            </tr>;
          }) }
        </tbody>
      </table>;
    }) }
  </div>;
}

export default BirdPage;
